import { Component } from 'react';

export class WarningTriangleSVG extends Component<{
    className?: string;
}> {
    render() {
        const { className } = this.props;
        return (
            <svg
                width="84"
                className={className}
                height="74"
                viewBox="0 0 84 74"
                fill="none"
                data-testid="WarningTriangleSVG"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M41.7719 1.00193C40.2129 1.07279 38.7247 1.95862 37.9452 3.26964L0.598708 66.1988C-0.18082 67.5807 -0.18082 69.3523 0.634141 70.7342C1.4491 72.1161 3.04359 73.0019 4.67351 73.0019H79.2956C80.9255 73.0019 82.52 72.1161 83.3704 70.7342C84.1853 69.3523 84.1853 67.5807 83.3704 66.1988L46.0239 3.26964C45.1735 1.85232 43.4727 0.931061 41.7719 1.00193ZM35.9963 23.998H48.0082L45.9885 51.9901H37.9806L35.9963 23.998ZM37.9806 55.9941H45.9885V64.0019H37.9806V55.9941Z"
                    fill="#DE1E1E"
                />
            </svg>
        );
    }
}
